"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = exports.ResultsNotFoundError = exports.OrbitsError = void 0;
const verror_1 = require("verror");
class OrbitsError extends verror_1.WError {
    constructor(arg0, ...arg1) {
        let options = { name: new.target.name };
        const message = `[${options.name}]`;
        if (arg0 === undefined) {
            arg1.unshift(message);
        }
        else if (typeof arg0 === "string") {
            arg1.unshift(`${message} ${arg0}`);
        }
        else {
            options = { ...arg0, ...options };
            if (arg1.length) {
                arg1[0] = `${message}${arg1[0] ? " " : ""}${arg1[0]}`;
            }
            else {
                arg1.unshift(message);
            }
        }
        super(options, arg1[0], ...arg1.slice(1));
        // Work around https://github.com/microsoft/TypeScript/issues/13965
        Object.setPrototypeOf(this, OrbitsError.prototype);
    }
}
exports.OrbitsError = OrbitsError;
class ResultsNotFoundError extends OrbitsError {
    constructor(arg0, ...arg1) {
        if (arg0 === undefined) {
            super();
        }
        else if (typeof arg0 === "string") {
            super(arg0, ...arg1);
        }
        else {
            if (arg1.length) {
                super(arg0, arg1[0], ...arg1);
            }
            else {
                super(arg0);
            }
        }
        // Work around https://github.com/microsoft/TypeScript/issues/13965
        Object.setPrototypeOf(this, ResultsNotFoundError.prototype);
    }
}
exports.ResultsNotFoundError = ResultsNotFoundError;
class ValidationError extends OrbitsError {
    constructor(arg0, ...arg1) {
        if (arg0 === undefined) {
            super();
        }
        else if (typeof arg0 === "string") {
            super(arg0, ...arg1);
        }
        else {
            if (arg1.length) {
                super(arg0, arg1[0], ...arg1);
            }
            else {
                super(arg0);
            }
        }
        // Work around https://github.com/microsoft/TypeScript/issues/13965
        Object.setPrototypeOf(this, ValidationError.prototype);
    }
}
exports.ValidationError = ValidationError;
//# sourceMappingURL=index.js.map